export default __webpack_public_path__ + "static/media/cloud.1b89f320.svg";